import { render, staticRenderFns } from "./exchangesTabComponent.vue?vue&type=template&id=89e7160e&"
import script from "./exchangesTabComponent.vue?vue&type=script&lang=js&"
export * from "./exchangesTabComponent.vue?vue&type=script&lang=js&"
import style0 from "./exchangesTabComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
